// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_YDlmi","content":"index_content_UaSJm","partner":"index_partner_duCwl","isPic":"index_isPic_QFnD9"};